var _rect, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAreaChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 100,
    viewBox: "0 0 121 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.377451,
    y: 0.377451,
    width: 120.245,
    height: 99.2451,
    rx: 3.62255,
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 0.754902
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9.75,
    x2: 111,
    y2: 9.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 29.75,
    x2: 111,
    y2: 29.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 49.75,
    x2: 111,
    y2: 49.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 69.75,
    x2: 111,
    y2: 69.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 89.75,
    x2: 111,
    y2: 89.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M102.695 60.511L109.683 80.4859C109.893 81.0856 110 81.7164 110 82.3517C110 85.4721 107.47 88.0017 104.35 88.0017H17.4655C12.7901 88.0017 9 84.2116 9 79.5362V56.4702C9 55.0464 9.48033 53.6643 10.3633 52.5473L11.1214 51.5884C14.028 47.9116 19.8819 49.1099 21.1099 53.633L21.4381 54.8416C22.9312 60.3411 30.8152 60.0937 31.9606 54.5114L32.3706 52.5135C33.4138 47.4296 40.5949 47.2069 41.9512 52.2163C43.1744 56.7341 49.4167 57.16 51.2422 52.8502L52.7035 49.4003C53.9171 46.5351 57.0612 45.0075 60.0637 45.8243L60.8402 46.0355C62.8875 46.5925 64.5812 48.0309 65.4622 49.961L67.2848 53.9534C69.416 58.6221 76.1778 58.2173 77.737 53.3278C79.3213 48.3593 86.2343 48.0494 88.2568 52.8563L89.5801 56.0014C90.6496 58.5434 93.7238 59.547 96.0872 58.1258C98.5478 56.6462 101.747 57.8009 102.695 60.511Z",
    fill: "url(#paint0_linear_2458_5375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 81.1985L102.699 60.413C101.748 57.7036 98.5504 56.5485 96.0869 58.0241V58.0241C93.7211 59.4412 90.6486 58.4375 89.5755 55.8971L88.2554 52.7718C86.2282 47.9727 79.3254 48.283 77.737 53.2446V53.2446C76.174 58.1272 69.4226 58.5325 67.2867 53.872L65.468 49.9038C64.5832 47.9732 62.8862 46.5356 60.8364 45.9802L60.0535 45.768C57.0551 44.9555 53.9168 46.4795 52.7011 49.3383L51.2405 52.7731C49.4107 57.076 43.1776 56.6494 41.9511 52.1374V52.1374C40.5907 47.1326 33.4166 47.3559 32.3702 52.4356L31.9606 54.4237C30.8117 60.0008 22.9362 60.2488 21.4387 54.755L21.1105 53.551C19.8798 49.0358 14.038 47.8372 11.1287 51.503L9 54.1851",
    stroke: "#14C9C9",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7577 49.9681L10.4507 67.8898C10.1524 68.7374 10 69.6295 10 70.528C10 74.9172 13.5582 78.4754 17.9474 78.4754H101.535C106.21 78.4754 110 74.6853 110 70.0099V33.1768C110 32.1125 109.724 31.0636 109.201 30.1367C106.381 25.1404 98.8497 26.3345 97.7581 31.9666L96.9006 36.3915C95.7985 42.0782 87.6686 42.1001 86.5357 36.4195L85.5252 31.3521C84.7524 27.4774 79.3569 27.1064 78.0611 30.839C76.7883 34.5054 71.5149 34.2339 70.6254 30.4561L69.9656 27.654C68.7879 22.6519 61.5931 22.8783 60.732 27.9445L56.1436 54.9422C55.7431 57.2988 53.8862 59.1386 51.526 59.5173C48.6025 59.9864 45.8216 58.0907 45.1897 55.1981L42.6621 43.626C41.333 37.5415 32.7149 37.3772 31.155 43.4067L30.13 47.3684C29.3363 50.4362 25.3868 51.2907 23.396 48.8254C21.4989 46.4762 17.7601 47.1198 16.7577 49.9681Z",
    fill: "url(#paint1_linear_2458_5375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 70.3115L16.7684 50.7367C17.7576 47.8759 21.5158 47.235 23.3972 49.6063V49.6063C25.3699 52.0925 29.3365 51.2434 30.1184 48.1674L31.1519 44.1018C32.6916 38.0447 41.3517 38.2072 42.6631 44.3178L45.205 56.1619C45.8272 59.0609 48.6139 60.9623 51.5402 60.4844V60.4844C53.8919 60.1004 55.7377 58.2611 56.1301 55.9109L60.7336 28.3431C61.5822 23.2612 68.8045 23.0376 69.9658 28.0573L70.6282 30.9209C71.5057 34.7139 76.8045 34.9827 78.0613 31.2979V31.2979C79.3404 27.5479 84.7599 27.9149 85.5217 31.8031L86.5354 36.9764C87.6523 42.6766 95.8142 42.6549 96.9007 36.9488L97.76 32.4363C98.839 26.7701 106.413 25.5554 109.21 30.5999L110 32.0254",
    stroke: "#165DFF",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2458_5375",
    x1: 59.5,
    y1: 32.2148,
    x2: 59.5,
    y2: 88.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C9C9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2458_5375",
    x1: 60,
    y1: 5,
    x2: 60,
    y2: 78.4754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165DFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165DFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChart);
export default __webpack_public_path__ + "static/media/area-chart.534d40b372adbf250e3ba837f799727c.svg";
export { ForwardRef as ReactComponent };